// src/api/system.ts
// 假設你已經有封裝好的 axios 實體 (例如 request 或 http)
import request from '@/utils/request'

export interface SystemCodeDto {
  codeKey: string
  codeCode: string
  codeName: string
}

export const systemApi = {
  // 呼叫我們剛剛在 .NET 寫好的下拉選單 API
  getDropdowns: (category: string) => {
    return request.get<SystemCodeDto[]>(`/api/GetOptions/dropdowns`, { params: { category } })
  },
  // 呼叫我們剛剛在 .NET 寫好的全站字典表 API
  getAllDropdowns: () => {
    return request.get<Record<string, SystemCodeDto[]>>(`/api/GetOptions/dropdowns/all`)
  }
}
